import { render, staticRenderFns } from "./activation-form.vue?vue&type=template&id=0b9fc5e3&scoped=true&lang=pug&"
import script from "./activation-form.vue?vue&type=script&lang=ts&"
export * from "./activation-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9fc5e3",
  null
  
)

export default component.exports